/* FundPicker — minimal select for tagging a transaction with a fund.
 * Caches the fund list at module scope so multiple pickers don't re-fetch.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let cache = null;
let pending = null;

export const invalidateFundsCache = () => { cache = null; };

const fetchFunds = async () => {
  if (cache) return cache;
  if (pending) return pending;
  pending = axios.get(`${BACKEND_URL}/api/admin/funds`, { withCredentials: true })
    .then((r) => { cache = r.data?.funds || []; return cache; })
    .finally(() => { pending = null; });
  return pending;
};

const FUND_TYPE_LABEL = {
  unrestricted: 'Unrestricted',
  temporarily_restricted: 'Temp Restricted',
  permanently_restricted: 'Perm Restricted',
  board_designated: 'Board-Designated',
};

const FundPicker = ({ value, onChange, allowNone = true, disabled = false, ariaLabel = 'Fund designation' }) => {
  const [funds, setFunds] = useState([]);
  useEffect(() => { fetchFunds().then(setFunds); }, []);

  return (
    <select value={value || ''} onChange={(e) => onChange(e.target.value || null)}
      disabled={disabled}
      className="w-full px-2.5 py-1.5 border border-[#E5E7EB] rounded text-xs bg-white"
      aria-label={ariaLabel} data-testid="fund-picker">
      {allowNone && <option value="">— No fund designation (default unrestricted) —</option>}
      <optgroup label="Unrestricted">
        {funds.filter((f) => f.fund_type === 'unrestricted').map((f) => (
          <option key={f.id} value={f.id}>{f.code} — {f.name}</option>
        ))}
      </optgroup>
      <optgroup label="Temporarily Restricted">
        {funds.filter((f) => f.fund_type === 'temporarily_restricted').map((f) => (
          <option key={f.id} value={f.id}>{f.code} — {f.name}</option>
        ))}
      </optgroup>
      <optgroup label="Other">
        {funds.filter((f) => !['unrestricted', 'temporarily_restricted'].includes(f.fund_type)).map((f) => (
          <option key={f.id} value={f.id}>{f.code} — {f.name} ({FUND_TYPE_LABEL[f.fund_type]})</option>
        ))}
      </optgroup>
    </select>
  );
};

export default FundPicker;
